var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let StatusIcon = class StatusIcon extends Vue {
    constructor() {
        super(...arguments);
        this.statusesColors = {
            [StatusEnum.NO_STATUS]: ['#e6e6e6'],
            [StatusEnum.BEHIND]: ['#FFD932'],
            [StatusEnum.ON_TRACK_BEHIND]: ['#FFD932', '#01A1FF'],
            [StatusEnum.ON_TRACK]: ['#01A1FF'],
            [StatusEnum.ON_TRACK_AHEAD]: ['#01A1FF', '#1DB100'],
            [StatusEnum.AHEAD]: ['#1DB100'], // green
        };
    }
    get statusState() {
        return this.status && this.status.state || 0;
    }
    get openSubjects() {
        return this.status && this.status.open_subjects || 0;
    }
    // It only has multiple statuses if student has open goals from prev / next preiod (behind on track and ahead on track)
    get hasMultipleStatuses() {
        if (!this.status) {
            return false;
        }
        return this.statusesColors[this.status.state].length > 1;
    }
    get formattedDeviation() {
        return this.status && this.status.deviation <= 0 ? this.status.deviation : `+${this.status.deviation}`;
    }
    get deviationColorClass() {
        if (!this.status && this.status.deviation) {
            return '';
        }
        if (this.status.deviation < 0) {
            return 'status-icon__deviation--negative';
        }
        if (this.status.deviation > 0) {
            return 'status-icon__deviation--positive';
        }
        else {
            return 'status-icon__deviation--neutral';
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], StatusIcon.prototype, "status", void 0);
StatusIcon = __decorate([
    Component({})
], StatusIcon);
export default StatusIcon;
var StatusEnum;
(function (StatusEnum) {
    StatusEnum[StatusEnum["NO_STATUS"] = 0] = "NO_STATUS";
    StatusEnum[StatusEnum["BEHIND"] = 1] = "BEHIND";
    StatusEnum[StatusEnum["ON_TRACK_BEHIND"] = 2] = "ON_TRACK_BEHIND";
    StatusEnum[StatusEnum["ON_TRACK"] = 3] = "ON_TRACK";
    StatusEnum[StatusEnum["ON_TRACK_AHEAD"] = 4] = "ON_TRACK_AHEAD";
    StatusEnum[StatusEnum["AHEAD"] = 5] = "AHEAD";
})(StatusEnum || (StatusEnum = {}));
